import {
    GET_REPORT_EXCEL,
    GET_REPORT_EXCEL_SUCCESS,
    GET_REPORT_EXCEL_FAIL,
    GET_REPORT_PDF,
    GET_REPORT_PDF_SUCCESS,
    GET_REPORT_PDF_FAIL,
    GET_REPORT_PROFITLOSS_EXCEL,
    GET_REPORT_PROFITLOSS_EXCEL_SUCCESS,
    GET_REPORT_PROFITLOSS_EXCEL_FAIL,
    GET_REPORT_PROFITLOSS_PDF,
    GET_REPORT_PROFITLOSS_PDF_SUCCESS,
    GET_REPORT_PROFITLOSS_PDF_FAIL,
    PREVIEW_REPORT_PDF,
    PREVIEW_REPORT_PDF_SUCCESS,
    PREVIEW_REPORT_PDF_FAIL,
    PREVIEW_REPORT_PROFITLOSS_PDF,
    PREVIEW_REPORT_PROFITLOSS_PDF_SUCCESS,
    PREVIEW_REPORT_PROFITLOSS_PDF_FAIL,
    GET_LKPM_REPORT_EXCEL,
    GET_LKPM_REPORT_EXCEL_SUCCESS,
    GET_LKPM_REPORT_EXCEL_FAIL,
    GET_LKPM_REPORT_PDF,
    GET_LKPM_REPORT_PDF_SUCCESS,
    GET_LKPM_REPORT_PDF_FAIL,
    PREVIEW_LKPM_REPORT_PDF,
    PREVIEW_LKPM_REPORT_PDF_SUCCESS,
    PREVIEW_LKPM_REPORT_PDF_FAIL,
    GET_LKPM_REPORT_PROFITLOSS_EXCEL,
    GET_LKPM_REPORT_PROFITLOSS_EXCEL_SUCCESS,
    GET_LKPM_REPORT_PROFITLOSS_EXCEL_FAIL,
    GET_LKPM_REPORT_PROFITLOSS_PDF,
    GET_LKPM_REPORT_PROFITLOSS_PDF_SUCCESS,
    GET_LKPM_REPORT_PROFITLOSS_PDF_FAIL,
    PREVIEW_LKPM_REPORT_PROFITLOSS_PDF,
    PREVIEW_LKPM_REPORT_PROFITLOSS_PDF_SUCCESS,
    PREVIEW_LKPM_REPORT_PROFITLOSS_PDF_FAIL,
  } from "./actionTypes";

  export const getReportExcel = (param) => ({
    type: GET_REPORT_EXCEL,
    payload: { param },
  });
  export const getReportExcelSuccess = () => ({
    type: GET_REPORT_EXCEL_SUCCESS,
  });
  export const getReportExcelFail = error => ({
    type: GET_REPORT_EXCEL_FAIL,
    payload: error,
  });

  export const getReportPdf = (param) => ({
    type: GET_REPORT_PDF,
    payload: { param },
  });
  export const getReportPdfSuccess = () => ({
    type: GET_REPORT_PDF_SUCCESS,
  });
  export const getReportPdfFail = error => ({
    type: GET_REPORT_PDF_FAIL,
    payload: error,
  });

  export const getReportProfitLossExcel = (param) => ({
    type: GET_REPORT_PROFITLOSS_EXCEL,
    payload: { param },
  });
  export const getReportProfitLossExcelSuccess = () => ({
    type: GET_REPORT_PROFITLOSS_EXCEL_SUCCESS,
  });
  export const getReportProfitLossExcelFail = error => ({
    type: GET_REPORT_PROFITLOSS_EXCEL_FAIL,
    payload: error,
  });

  export const getReportProfitLossPdf = (param) => ({
    type: GET_REPORT_PROFITLOSS_PDF,
    payload: { param },
  });
  export const getReportProfitLossPdfSuccess = () => ({
    type: GET_REPORT_PROFITLOSS_PDF_SUCCESS,
  });
  export const getReportProfitLossPdfFail = error => ({
    type: GET_REPORT_PROFITLOSS_PDF_FAIL,
    payload: error,
  });

  export const previewReportPdf = (param) => ({
    type: PREVIEW_REPORT_PDF,
    payload: { param },
  });
  export const previewReportPdfSuccess = () => ({
    type: PREVIEW_REPORT_PDF_SUCCESS,
  });
  export const previewReportPdfFail = error => ({
    type: PREVIEW_REPORT_PDF_FAIL,
    payload: error,
  });

  export const previewReportProfitLossPdf = (param) => ({
    type: PREVIEW_REPORT_PROFITLOSS_PDF,
    payload: { param },
  });
  export const previewReportProfitLossPdfSuccess = () => ({
    type: PREVIEW_REPORT_PROFITLOSS_PDF_SUCCESS,
  });
  export const previewReportProfitLossPdfFail = error => ({
    type: PREVIEW_REPORT_PROFITLOSS_PDF_FAIL,
    payload: error,
  });

  export const getLkpmReportExcel = (param) => ({
    type: GET_LKPM_REPORT_EXCEL,
    payload: { param },
  });
  export const getLkpmReportExcelSuccess = () => ({
    type: GET_LKPM_REPORT_EXCEL_SUCCESS,
  });
  export const getLkpmReportExcelFail = error => ({
    type: GET_LKPM_REPORT_EXCEL_FAIL,
    payload: error,
  });

  export const getLkpmReportPdf = (param) => ({
    type: GET_LKPM_REPORT_PDF,
    payload: { param },
  });
  export const getLkpmReportPdfSuccess = () => ({
    type: GET_LKPM_REPORT_PDF_SUCCESS,
  });
  export const getLkpmReportPdfFail = error => ({
    type: GET_LKPM_REPORT_PDF_FAIL,
    payload: error,
  });

  export const previewLkpmReportPdf = (param) => ({
    type: PREVIEW_LKPM_REPORT_PDF,
    payload: { param },
  });
  export const previewLkpmReportPdfSuccess = () => ({
    type: PREVIEW_LKPM_REPORT_PDF_SUCCESS,
  });
  export const previewLkpmReportPdfFail = error => ({
    type: PREVIEW_LKPM_REPORT_PDF_FAIL,
    payload: error,
  });

  export const getLkpmReportProfitLossExcel = (param) => ({
    type: GET_LKPM_REPORT_PROFITLOSS_EXCEL,
    payload: { param },
  });
  export const getLkpmReportProfitLossExcelSuccess = () => ({
    type: GET_LKPM_REPORT_PROFITLOSS_EXCEL_SUCCESS,
  });
  export const getLkpmReportProfitLossExcelFail = error => ({
    type: GET_LKPM_REPORT_PROFITLOSS_EXCEL_FAIL,
    payload: error,
  });

  export const getLkpmReportProfitLossPdf = (param) => ({
    type: GET_LKPM_REPORT_PROFITLOSS_PDF,
    payload: { param },
  });
  export const getLkpmReportProfitLossPdfSuccess = () => ({
    type: GET_LKPM_REPORT_PROFITLOSS_PDF_SUCCESS,
  });
  export const getLkpmReportProfitLossPdfFail = error => ({
    type: GET_LKPM_REPORT_PROFITLOSS_PDF_FAIL,
    payload: error,
  });

  export const previewLkpmReportProfitLossPdf = (param) => ({
    type: PREVIEW_LKPM_REPORT_PROFITLOSS_PDF,
    payload: { param },
  });
  export const previewLkpmReportProfitLossPdfSuccess = () => ({
    type: PREVIEW_LKPM_REPORT_PROFITLOSS_PDF_SUCCESS,
  });
  export const previewLkpmReportProfitLossPdfFail = error => ({
    type: PREVIEW_LKPM_REPORT_PROFITLOSS_PDF_FAIL,
    payload: error,
  });